import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../../assets/css/scss/section/player/_profileLatestNewsSection.scss";
import preventRightClick from "../../../common/preventRightClick";

export default function ProfileLatestNewsSection(props: any) {
    const propsData = props?.data;
    return (
        <div className="profile-news-section">
            <div className="news-block-section theme-light-white">
                <Row>
                    {propsData?.map((data: any) => (
                        <Col md={4} xl={3} className="mb-5">
                            <div className="news-img-item mb-3">
                                <Link to={"/news/" + data?.identifier} className="w-100">
                                    <Image
                                        src={data?.image || "/assets/images/story-blog.jpg"}
                                        alt="story"
                                        className="w-100"
                                        fluid
                                        onContextMenu={(e) => preventRightClick(e)}
                                    />
                                </Link>
                            </div>
                            <h3 className="h4 bold line-clamp-2">
                                <Link to={"/news/" + data?.identifier}>{data?.title}</Link>
                            </h3>
                            <p className="font-14 line-clamp-4">
                                {data?.subtitle}
                            </p>
                        </Col>
                    ))}
                    {/* <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">Washington National 2021 Prospects Chat</Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                Glaser: Baseball’s Golden age of Young Talent Is Now
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col>
                    <Col md={4} xl={3} className="mb-5">
                        <div className="story-img-item mb-3">
                            <Link to="/" className="w-100">
                                <Image
                                    src="/assets/images/story-blog.jpg"
                                    alt="story"
                                    className="w-100"
                                    fluid
                                />
                            </Link>
                        </div>
                        <h3 className="h4 bold">
                            <Link to="/">
                                2020 All-MLB First and Second Teams and Their Status
                            </Link>
                        </h3>
                        <p className="font-14">
                            Lorem ipsum dolor sit ame consecte tur adipiscing elit, sed do
                            eiusmod tempor incididunt ut our labore et dolore magna aliquac
                            uis ipsum.
                        </p>
                    </Col> */}
                </Row>
            </div>
        </div>
    );
}
